"use strict";
exports.__esModule = true;
var ChartScopeRequest_1 = require("./ChartScopeRequest");
var ChartBreakdownRequest_1 = require("./ChartBreakdownRequest");
var ChartHeader = /** @class */ (function () {
    function ChartHeader(_a) {
        var scope = _a.scope, breakdowns = _a.breakdowns;
        var _this = this;
        this.toJSON = function () { return ({
            scope: _this.scope,
            breakdowns: _this.breakdowns
        }); };
        this.scope = scope;
        this.breakdowns = breakdowns;
    }
    ChartHeader.fromJSON = function (json) {
        var _a = Object.assign({}, json), scope = _a.scope, breakdowns = _a.breakdowns;
        var _scope = scope ? ChartScopeRequest_1["default"].fromJSON(scope) : undefined;
        var _breakdowns = breakdowns ? breakdowns.map(function (item) { return ChartBreakdownRequest_1["default"].fromJSON(item); }) : undefined;
        return new ChartHeader({
            scope: _scope,
            breakdowns: _breakdowns
        });
    };
    return ChartHeader;
}());
exports["default"] = ChartHeader;
